import { FC, HTMLAttributes } from "react";
import { useStyles } from "./ShopBundle.style";
import {
  Button,
  GemNumber,
  Image,
  Typography,
  TypographyVariant,
} from "@onmo/ui";
import { Inventory, InventoryBundleData } from "@onmo/graphql/graphql";
import clsx from "classnames";

interface IShopBundleProps {
  inventory: Inventory;
  fullWidth?: boolean;
}

export const ShopBundle: FC<
  IShopBundleProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const { inventory, fullWidth, ...otherProps } = props;
  const classes = useStyles();
  const inventoryBundle = inventory?.data as InventoryBundleData;

  if (!inventory) return null;

  return (
    <div className={clsx(classes.root, { fullWidth })} {...otherProps}>
      <Image
        src={inventoryBundle?.previewUrl}
        width={120}
        height={120}
        radius={8}
      />
      <Typography
        variant={TypographyVariant.BodyB5Bold}
        className={classes.title}
      >
        {inventory.title}
      </Typography>
      {inventory.costs[0]?.amount && !inventory.isPurchased && (
        <Button size="small" fullWidth>
          <GemNumber amount={inventory.costs[0].amount} gemSize={16} />
        </Button>
      )}
    </div>
  );
};

export default ShopBundle;
